import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import localeEn from 'locales/en/app';
import localeTw from 'locales/tw/app';
import headerMobileTw from 'images/landing/header_mobile.png';
import headerMobileEn from 'images/en/header_mobile.png';
import headerMobileSmallTw from 'images/landing/header_mobile_m.png';
import headerMobileSmallEn from 'images/en/header_mobile_m.png';
import usageMapTw from 'images/landing/usage_map.png';
import usageMapEn from 'images/en/usage_map.png';
import navbarLogoTw from 'images/logo_mochi.svg';
import navbarLogoEn from 'images/en/logo_mochi.svg';
import logoMochiRefuelingTw from 'images/logo_refueling.svg';
import logoMochiRefuelingEn from 'images/en/logo_refueling.svg';
import logoMochiParkingTw from 'images/logo_parking.svg';
import logoMochiParkingEn from 'images/en/logo_parking.svg';
import logoMochiStreetParkingTw from 'images/logo_streetparking.svg';
import logoMochiStreetParkingEn from 'images/en/logo_streetparking.svg';
import logoMochiAutoRepairTw from 'images/logo_autorepair.svg';
import logoMochiAutoRepairEn from 'images/en/logo_autorepair.svg';
import logoAutopassTw from 'images/logo_autopass.svg';
import logoAutopassEn from 'images/en/img_autopass_en.svg';

const resources = {
  en: {
    app: localeEn,
    images: {
      navbar_logo: navbarLogoEn,
      header_mobile: headerMobileEn,
      header_mobile_m: headerMobileSmallEn,
      usage_map: usageMapEn,
      refueling_logo: logoMochiRefuelingEn,
      parking_logo: logoMochiParkingEn,
      on_street_parking_logo: logoMochiStreetParkingEn,
      auto_repair_logo: logoMochiAutoRepairEn,
      logo_autopass: logoAutopassEn,
    },
  },
  tw: {
    app: localeTw,
    images: {
      navbar_logo: navbarLogoTw,
      header_mobile: headerMobileTw,
      header_mobile_m: headerMobileSmallTw,
      usage_map: usageMapTw,
      refueling_logo: logoMochiRefuelingTw,
      parking_logo: logoMochiParkingTw,
      on_street_parking_logo: logoMochiStreetParkingTw,
      auto_repair_logo: logoMochiAutoRepairTw,
      logo_autopass: logoAutopassTw,
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'tw',
  ns: ['app', 'images'],
  fallbackLng: 'tw',
  defaultNS: 'app',
});

export default i18n;
